module.exports = __webpack_public_path__ + "img/edge_restauration_auberge.b85cb352.svg";